import Input from 'antd/lib/input'
import './index.less'

export default Input



// WEBPACK FOOTER //
// ./src/elements/text-input/index.js